import {vinRe} from '@deliveriesondemand/dod-regexes';
import {sanitizeVIN} from '@deliveriesondemand/dod-utils';
import {get} from 'lodash';
import {useEffect, useState} from 'react';
import Loader from 'react-loader-spinner';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

import TextInput from '-/components/fields/TextInput';
import {lookupVIN} from '-/api/api';
import {Control, ControlGroup} from '-/components/fields/Control';

const styles = () => ({
    alert: {
        margin: 20
    }
});

const VIN = props => {
    const {buyerName: name, classes = {}, handleChange, includeExperian, includeNADA, showErrors, theme = {}, vehicleInfo = {}} = props;
    const {year, make, model, vin} = vehicleInfo;
    const initialVinValidity = vin ? vinRe.test(vin) : true;
    const [vinValid, setVinValid] = useState(initialVinValidity);
    const [loading, setLoading] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState('');
    const primaryColor = get(theme, 'colors.primary');
    const showVehicle = !!(year && make && model && vinValid);
    const vehicle = [year, make, model].join(' ');

    const handleVinChange = async() => {
        if (!vin) {
            return false;
        }
        
        setLoading(true);
        let newFeedbackMsg = feedbackMsg;
        let newVinValid = vinRe.test(vin);

        if (!newVinValid) {
            newFeedbackMsg = 'VIN Invalid';

            handleChange({
                vehicle: {
                    make: undefined,
                    model: undefined,
                    ucgVehicleId: undefined,
                    year: undefined
                },
                trims: []
            });
        } else {
            newVinValid = true;

            try {
                newFeedbackMsg = '';
                const {lienholder, plateNumber, plateState, trims = [], vehicle = {}} = await lookupVIN({
                    includeExperian,
                    includeNADA,
                    name, 
                    vin
                }) || {};
                
                handleChange({lienholder, plateNumber, plateState, trims, vehicle});
            } catch (ex) {
                newFeedbackMsg = 'We could not find that VIN';
            }
        }

        setFeedbackMsg(newFeedbackMsg);
        setVinValid(newVinValid);
        setLoading(false);
    };

    const onVinChange = incomingVin => {
        const sanitizedVin = sanitizeVIN(incomingVin);

        handleChange({
            vehicle: {
                vin: sanitizedVin && sanitizedVin.toUpperCase ? sanitizedVin.toUpperCase() : sanitizedVin
            }
        });
    };

    useEffect(() => {
        handleVinChange(vin);
    }, [vin]);

    return (
        <ControlGroup labelWidth={200}>
            <Control>
                <TextInput
                    isInvalid={!vinValid && showErrors}
                    label="VIN"
                    type="text"
                    name="vin"
                    onChange={onVinChange}
                    placeholder="Enter VIN"
                    value={vin} />
            </Control>
            {loading && (
                <Loader type="ThreeDots" color={primaryColor} height="100" width="100" />
            )}
            <p className={classes.alert}>
                {(feedbackMsg && !showVehicle) && (
                    <span>{feedbackMsg}</span>
                )}
                {showVehicle && (
                    <span>We Found a: <b>{vehicle}</b></span>
                )}
            </p>
        </ControlGroup>
    );
};

VIN.propTypes = {
    handleChange: PropTypes.func.isRequired,
    showErrors: PropTypes.bool
};

export default injectSheet(styles)(VIN);
